import React, { Component } from 'react';
import API from '../../../middleware/API';
import Pagination from '../../Pagination';
import moment from 'moment';
import EditRentall from './EditRentall';
import PrintRentall from './PrintRentall';
import PrintApplyPayment from './PrintApplyPayment';
import ApplyPaymentModal from './ApplyPaymentModal';
import swal from 'sweetalert2';
import axios from 'axios';
import PrintPortal from './PrintPortal';
import { GetStoreRole ,GetStoreDetailRole} from '../../../const/constant';
import { orderBy } from 'lodash';
import FileUploader from '../../FileUploader';

class RentalList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currPage: 1,
      countOfPage: 10,
      totalPage: 1,
      totalCount: 0,
      rentalList: [],
      tenantList: [],
      showEdit: false,
      showPrint: false,
      editType: 'ADD',
      orderBy:'createAt',
      editData: {
        
      },
            selectedFile: null,

      statusFilter: -1, // 新增狀態過濾
      codeFilter: '', // 新增狀態過濾
      rentType: 'advance', // 新增,
      detailRoleId:  GetStoreDetailRole(localStorage.getItem('current_store_id')),
      downloadYear: new Date().getFullYear(),
      downloadMonth: new Date().getMonth() + 1,
      recordCount: 0,
      showApplyPayment: false,
      applyPaymentData: null,
      showPrintApplyPayment: false,
      printApplyPaymentData: null,
    };
    this.handleChangePage = this.handleChangePage.bind(this);
    this.loadRentalList = this.loadRentalList.bind(this);
    this.handleAdd = this.handleAdd.bind(this);
    this.handleEdit = this.handleEdit.bind(this);
    this.onChangeFunc = this.onChangeFunc.bind(this);
    this.saveFunc = this.saveFunc.bind(this);
    this.lockFunc = this.lockFunc.bind(this);
    this.toggleFunc = this.toggleFunc.bind(this);
    this.togglePringFunc = this.togglePringFunc.bind(this);
    this.handleStatusFilterChange = this.handleStatusFilterChange.bind(this);
    this.handleCodeFilterChange = this.handleCodeFilterChange.bind(this);
    this.handleOrderFilterChange = this.handleOrderFilterChange.bind(this);
    this.showUploadModal = this.showUploadModal.bind(this);
    this.uploadFile = this.uploadFile.bind(this);
    this.handleDownloadExcel = this.handleDownloadExcel.bind(this);
    this.handleApplyPayment = this.handleApplyPayment.bind(this);
    this.saveApplyPaymentFunc = this.saveApplyPaymentFunc.bind(this);
    this.toggleApplyPaymentFunc = this.toggleApplyPaymentFunc.bind(this);
    this.handlePrintApplyPayment = this.handlePrintApplyPayment.bind(this);
    this.togglePrintApplyPaymentFunc = this.togglePrintApplyPaymentFunc.bind(this);
        this.submitForm = this.submitForm.bind(this);
    this.handleSelectFile = this.handleSelectFile.bind(this);
  }
  async uploadFile(rentalId, file) {
            // 1. 建立 FormData 物件，這相當於一個表單
            const formData = new FormData();
            
            // 2. 將檔案和 RentalId 加入到 FormData
            //    *** 重要 ***:
            //    'File' 和 'RentalId' 這兩個鍵名(key)必須與你的 C# 後端程式碼完全一致
            //    HttpContext.Current.Request.Files.Get("File")
            //    HttpContext.Current.Request.Params.Get("RentalId")
            formData.append('File', file);
            formData.append('RentalId', rentalId);

            // 3. 設定 API 的 URL
            const url = '/Income/Rentall/Account'; // 請根據你的實際路由調整

            // 4. 使用 axios 發送 POST 請求
            try {
                const response = await API.post(url, formData);

                // 假設你的 APIResponse 物件格式為 { Success: true, Data: "...", Message: [] }
                if (response.data && response.data.Success) {
                    return response.data; // 將成功的結果回傳給 SweetAlert
                } else {
                    // 如果 API 回應 200 OK，但業務邏輯失敗
                    throw new Error(response.data.Message.join(', ') || '上傳失敗，但未提供錯誤訊息。');
                }
            } catch (error) {
                // 處理網路錯誤或伺服器回傳非 2xx 的狀態碼
                console.error('上傳失敗:', error);
                // 重新拋出錯誤，讓 SweetAlert 知道操作失敗
            }
        }
lockFunc(rentalld){
  swal.fire({
    title: '您確定要鎖定這筆租借紀錄嗎？',
    text: "鎖定後將無法編輯此筆資料！",
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#d33',
    cancelButtonColor: '#3085d6',
    confirmButtonText: '是',
    cancelButtonText: '取消'
  }).then((result) => {
    if (result.value) {
    API.patch(`Income/Rentall/Lock/${rentalld.id}`).then(res => {
      swal.fire('已鎖定!', '該租借紀錄已被成功鎖定。', 'success');
      this.loadRentalList(); // 重新載入租借列表
    });

    }
  });
}

  submitForm(){
    const formData = new FormData();
    formData.append("File", this.state.selectedFile);
    axios.post(process.env.REACT_APP_NODE_ENV === 'development'?'https://www.liangshishu.link:46890/api/'+`Income/Summary`:'https://www.liangshishu.link:46888/api/'+`Income/Summary`, formData, {
        headers: {
          'Authorization': 'Bearer ' + localStorage.getItem('access_token'),
          'StoreId': localStorage.getItem('current_store_id')
          // 不要手動加 Content-Type
        },
       responseType: 'blob'}).then((response) => {
           const url = window.URL.createObjectURL(new Blob([response.data]));
           const link = document.createElement('a');
           link.href = url;
           link.setAttribute('download', `轉帳傳票.xlsx`); //or any other extension
           document.body.appendChild(link);
           link.click();
           });
  };


showUploadModal(rentalId) {
            swal.fire({
                title: '上傳帳戶圖片',
                // 使用 html 屬性插入一個檔案選擇器
                html: '<input type="file" id="fileUploader" class="swal2-input" accept="image/*">',
                icon: 'info',
                showCancelButton: true,
                confirmButtonText: '上傳',
                cancelButtonText: '取消',
                showLoaderOnConfirm: true, // 在點擊確認後顯示載入動畫

                // 在視窗開啟時，可以做一些初始化的事情
                didOpen: () => {
                    // 你可以在這裡對 input 做一些操作，例如增加事件監聽
                },
                
                // 這是關鍵！在使用者點擊 "上傳" 後執行
                preConfirm: () => {
                    const fileInput = document.getElementById('fileUploader');
                    const file = fileInput.files[0];

                    // 驗證：檢查使用者是否選擇了檔案
                    if (!file) {
                        swal.showValidationMessage('請選擇一個檔案');
                        return false; // 阻止執行
                    }

                    // 執行我們的非同步上傳函式
                    // SweetAlert 會等待這個 Promise 完成
                    return this.uploadFile(rentalId, file);
                },
                // 允許 preConfirm 函式之外的點擊來關閉視窗
                allowOutsideClick: () => !swal.isLoading()

            }).then((result) => {
                // result.value 會是 preConfirm 成功後回傳的值 (也就是 response.data)
                if (result.isConfirmed) {
                    swal.fire({
                        title: '成功！',
                        text: `檔案已成功上傳。`,
                        icon: 'success'
                    });
                    // 在這裡你可以執行後續操作，例如重新整理頁面或更新 UI
                    // console.log('API 回應:', result.value);
                    this.loadRentalList(); // 重新載入租借列表
                }
            }).catch(error => {
                // 如果 preConfirm 中的 Promise 被拒絕 (rejected) 或拋出錯誤
                // SweetAlert 會自動顯示錯誤訊息
                swal.fire({
                    title: '上傳失敗',
                    text: error.message,
                    icon: 'error'
                });
            });
        }

  handleStatusFilterChange(e) {
    this.setState(
      { statusFilter: Number(e.target.value), currPage: 1 },
      () => this.loadRentalList()
    );
  }

  handleCodeFilterChange(e) {
    this.setState(
      { codeFilter: e.target.value, currPage: 1 },
      () => this.loadRentalList()
    );
  }

  handleOrderFilterChange(e) {
    console.log(e.target.value);
    this.setState(
      { orderBy: e.target.value, currPage: 1 },
      () => this.loadRentalList()
    );
  }

  handleDownloadExcel() {
    const { downloadYear, downloadMonth } = this.state;
    let currentYear = downloadYear;
    let currentMonth = downloadMonth;
    
    // 获取记录数的函数
    const fetchRecordCount = async (year, month) => {
      try {
        const response = await API.get(`Rentall/Count?year=${year}&month=${month}`);
        console.log(response)
        
        const recordCount = response || 0;
        
        // 更新 state 中的 recordCount
        this.setState({ recordCount: recordCount });
        
        // 更新显示
        const countDisplay = document.getElementById('recordCountDisplay');
        if (countDisplay) {
          countDisplay.innerHTML = `<span style="font-size: 16px; color: #2196F3;"><strong>共 ${recordCount} 筆資料</strong></span>`;
        }
        
        // 动态禁用/启用下载按钮
        const confirmBtn = document.querySelector('.swal2-confirm');
        if (confirmBtn) {
          if (recordCount === 0) {
            confirmBtn.disabled = true;
            confirmBtn.style.opacity = '0.5';
            confirmBtn.style.cursor = 'not-allowed';
          } else {
            confirmBtn.disabled = false;
            confirmBtn.style.opacity = '1';
            confirmBtn.style.cursor = 'pointer';
          }
        }
      } catch (error) {
        this.setState({ recordCount: 0 });
        const countDisplay = document.getElementById('recordCountDisplay');
        if (countDisplay) {
          countDisplay.innerHTML = '<span style="color: #f44336;">無法取得資料數量</span>';
        }
        
        // 禁用下载按钮
        const confirmBtn = document.querySelector('.swal2-confirm');
        if (confirmBtn) {
          confirmBtn.disabled = true;
          confirmBtn.style.opacity = '0.5';
          confirmBtn.style.cursor = 'not-allowed';
        }
      }
    };
    
    swal.fire({
      title: '下載場租Excel(完成+鎖定)',
      html: `
        <div style="text-align: left;">
          <label style="display: block; margin-bottom: 10px;">
            年份：
            <input type="number" id="downloadYear" value="${downloadYear}" min="2000" max="2099" style="width: 80px; margin-left: 10px; padding: 5px; border: 1px solid #ddd; border-radius: 4px;" />
          </label>
          <label style="display: block; margin-bottom: 15px;">
            承租月份：
            <select id="downloadMonth" style="width: 80px; margin-left: 10px; padding: 5px; border: 1px solid #ddd; border-radius: 4px;">
              ${[1,2,3,4,5,6,7,8,9,10,11,12].map(m => `<option value="${m}" ${m === downloadMonth ? 'selected' : ''}>${m}月</option>`).join('')}
            </select>
          </label>
          <div style="font-size: 14px; color: #666; padding: 10px; background-color: #f5f5f5; border-radius: 4px; text-align: center;">
            <strong id="recordCountDisplay">查詢中...</strong>
          </div>
        </div>
      `,
      showCancelButton: true,
      confirmButtonText: '下載',
      cancelButtonText: '取消',
      onOpen: () => {
        const yearInput = document.getElementById('downloadYear');
        const monthSelect = document.getElementById('downloadMonth');
        yearInput.focus();
        
        // 初次加载记录数
        fetchRecordCount(currentYear, currentMonth);
        
        // 监听年份改变
        yearInput.addEventListener('change', (e) => {
          currentYear = Number(e.target.value);
          if (currentYear >= 2000 && currentYear <= 2099) {
            fetchRecordCount(currentYear, currentMonth);
          }
        });
        
        // 监听月份改变
        monthSelect.addEventListener('change', (e) => {
          currentMonth = Number(e.target.value);
          fetchRecordCount(currentYear, currentMonth);
        });
      }
    }).then((result) => {
      if (result.value) {

        const year = Number(document.getElementById('downloadYear').value);
        const month = Number(document.getElementById('downloadMonth').value);
        
        if (!year || year < 2000 || year > 2099) {
          swal.fire('錯誤', '年份無效', 'error');
          return;
        }
        
        if (!month || month < 1 || month > 12) {
          swal.fire('錯誤', '月份無效', 'error');
          return;
        }


        axios({
           url:process.env.REACT_APP_NODE_ENV === 'development'?'https://www.liangshishu.link:46890/api/'+`Rentall/Generate?year=${year}&month=${month}`:'https://www.liangshishu.link:46888/api/'+`Rentall/Generate?year=${year}&month=${month}`,
           method: 'GET',
           headers:{
 'Authorization': 'bearer ' + localStorage.getItem('access_token'),
       'StoreId':1 },
       responseType: 'blob'}).then((response) => {
           const url = window.URL.createObjectURL(new Blob([response.data]));
           const link = document.createElement('a');
           link.href = url;
           link.setAttribute('download', `場租明細${year}年${month}月_${new Date().toLocaleDateString()}.xlsx`); //or any other extension
           document.body.appendChild(link);
           link.click();
           }).catch((error) => {
           swal.fire({
             type: 'error',
             title: '下載失敗',
            text: error.response && error.response.status === 500 ? '伺服器錯誤，請稍後再試' : '下載報表時發生錯誤',
             heightAuto: false,
           });
         });

      }
    });
  }

  handleApplyPayment(item) {
    this.setState({
      showApplyPayment: true,
      applyPaymentData: { ...item },
    });
  }

  saveApplyPaymentFunc(paymentData) {
    const { applyPaymentData } = this.state;
    const rentalId = applyPaymentData.id;

    const apiData = {
      paymentMethod: paymentData.paymentMethod,
      paymentBankName: paymentData.paymentBankName,
      paymentAccountNumber: paymentData.paymentAccountNumber,
      paymentAccountHolderName: paymentData.paymentAccountHolderName,
      paymentReceiptAmount: paymentData.paymentReceiptAmount,
      paymentRemarks: paymentData.paymentRemarks,
      paymentTotalAmount: paymentData.paymentTotalAmount,
    };

    API.post(`Income/Rentall/${rentalId}/Apply`, apiData).then(res => {
      swal.fire('成功', '已申請請款單', 'success');
      this.setState({ showApplyPayment: false }, () => this.loadRentalList());
    }).catch(error => {
      swal.fire('錯誤', error.message || '申請失敗，請重試', 'error');
    });
  }

  toggleApplyPaymentFunc() {
    this.setState({ showApplyPayment: false });
  }

  handlePrintApplyPayment(item) {
    console.log('PrintApplyPayment Data:', item);
    this.setState({
      showPrintApplyPayment: true,
      printApplyPaymentData: { rentalData: item, paymentData: {} },
    });
  }

  togglePrintApplyPaymentFunc() {
    this.setState({ showPrintApplyPayment: false });
  }

  componentDidMount() {
    this.loadRentalList();
  }

  loadRentalList() {
    const { currPage, countOfPage ,statusFilter, codeFilter,orderBy} = this.state;
    API.get(`Income/Rentall?code=${codeFilter}&status=${statusFilter}&page=${currPage}&count=${countOfPage}&orderBy=${orderBy}`).then((response) => {
      if (response) {
        const { totalCount, rentallIncomeList, tenantList } = response;
                console.log(rentallIncomeList);

        this.setState({
          rentalList: rentallIncomeList || [],
          tenantList: tenantList || [],
          totalCount: totalCount || 0,
          totalPage: Math.ceil((totalCount || 0) / countOfPage),
        });
      }
    });
  }

  handleChangePage(page) {
    this.setState(
      { currPage: page },
      () => this.loadRentalList()
    );
  }

  handleAdd(rentType) {
    this.setState({
      showEdit: true,
      editType: 'ADD',
      editData: {status: 1 },
      rentType: rentType || 'advance',
    });
  }

  handleEdit(item) {
    this.setState({
      showEdit: true,
      editType: 'EDIT',
      rentType: item.code.indexOf('R') != -1 ? 'advance' : 'onsite',
      editData: { ...item },
    });
  }

// handlePrint 只需要設置狀態
handlePrint(item) {
  this.setState({
    showPrint: true, // 啟用 Portal 渲染
    // editType: 'EDIT', // 保持 EDIT 或改為 PRINT
    editData: { ...item },
  });
}

// togglePringFunc 用於關閉 Portal (當新視窗被關閉或卸載時呼叫)
togglePringFunc() {
  this.setState({ showPrint: false });
}

// onChangeFunc(field, value) {
//   // Always update the changed field first
//   let newEditData = {
//     ...this.state.editData,
//     [field]: value
//   };

//   // Check if the change requires updating 'totalAmount'
//   if (field === 'mealFee' || field === 'rentalAmount') {
//     // Get the potentially updated values for calculation
//     // Use the newly received 'value' for the field that was just changed,
//     // and use the existing state for the other field.
//     const mealfee = field === 'mealFee' ? value : this.state.editData.mealfee;
//     const rentalAmount = field === 'rentalAmount' ? value : this.state.editData.rentalAmount;

//     // Convert values to numbers and calculate the total.
//     // Use Number() to ensure calculation is numerical,
//     // and handle potential non-numeric inputs (e.g., initial empty string) by defaulting to 0.
//     const numericMealfee = Number(mealfee) || 0;
//     const numericRentalAmount = Number(rentalAmount) || 0;

//     const newTotalAmount = numericMealfee + numericRentalAmount;

//     // Update the 'totalAmount' field in the new data object
//     newEditData.totalAmount = newTotalAmount;
//   }

//   // Update the component state with the new data
//   this.setState({
//     editData: newEditData
//   });
// }
  onChangeFunc(field, value) {
    this.setState(prev => ({
      editData: { ...prev.editData, [field]: value }
    }));
  }

  handleSelectFile(event) {
    this.setState({selectedFile: event});
  }
  saveFunc() {
    const { editType, editData } = this.state;
    if (editType === 'ADD') {
      API.post('Income/Rentall', editData).then(res => {
        if(res == 1){
          swal({'title':'新增成功','type':'success'});
                  this.setState({ showEdit: false }, () => this.loadRentalList());

        }else{
          swal({'title':'新增失敗','text':'新增失敗，請聯絡工程師','type':'error'});
        }
      });
    } else if (editType === 'EDIT') {
      // 假設 editData 有 rentallId 欄位
      API.put(`Income/Rentall/${editData.id}`, editData).then(res => {
        if(res == 1){
          swal({'title':'編輯成功','type':'success'});
                  this.setState({ showEdit: false }, () => this.loadRentalList());

        }else{
          swal({'title':'編輯失敗','text':'編輯失敗，請聯絡工程師','type':'error'});
        }
      });
    }
  }
  handleDelete = (item) => {
    if (window.confirm('確定要刪除這筆資料嗎？')) {
      API.delete(`Income/Rentall/${item.id}`).then(res => {
        this.loadRentalList();
      });
    }
  }
  toggleFunc() {
    this.setState({ showEdit: false });
  }

  render() {
    const { statusFilter,codeFilter, orderBy, rentalList, currPage, totalPage, showEdit, showPrint, showApplyPayment, showPrintApplyPayment, editType, editData, rentType, detailRoleId, applyPaymentData, printApplyPaymentData } = this.state;

    var createButton = null;

    if(detailRoleId ==='15' || detailRoleId ==='40'|| detailRoleId ==='19'){
      createButton = (
        <button className="btn btn-md save hide-on-print" onClick={() => this.handleAdd('advance')}>新增預收租借</button>
      );
    }else{
      createButton = '';
    }

    return (
      <div className="p-signTime">

          <div className="u-block u-block--fixHeight hide-on-print">
          <div className="u-title">租借紀錄
            
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              {createButton}
              <button className="btn btn-md save m-l-8 hide-on-print" onClick={() => this.handleAdd('onsite')}>新增現場租借</button>
              <button className="btn btn-md save m-l-8 hide-on-print" onClick={this.handleDownloadExcel} style={{ backgroundColor: '#4CAF50' }}>下載場租Excel</button>
            </div>
            <form style={{display:(localStorage.getItem('username') === '22' || detailRoleId === '40' || detailRoleId === '15')?'block':'none'}}>
              下載轉帳傳票:
              <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                <FileUploader
                  onFileSelectSuccess={this.handleSelectFile}
                  onFileSelectError={({ error }) => alert(error)}
                />
                <button type='button' onClick={this.submitForm}>上傳營業總表</button>
              </div>
            </form>
          </div>
            <div style={{ marginBottom: 16 }}>
<div>狀態顏色說明:<span style={{backgroundColor:'#ffe4ea'}}>待處理</span>、<span style={{backgroundColor:'#fff7e0'}}>待審查</span>、<span style={{backgroundColor:'#e0f3ff'}}>待退款</span>、<span style={{backgroundColor:'#e0ffe4'}}>已完成</span>跟<span style={{backgroundColor:'#999'}}>已鎖定</span>(鎖定後不可編輯跟刪除)</div>
          <label style={{ marginRight: 8 }}>排序：</label>
          <select value={orderBy} onChange={this.handleOrderFilterChange} style={{ minWidth: 120 }}>
            <option value={'createAt'}>新增日期</option>
            <option value={'rentDate'}>場租日期</option>

          </select>
          <label style={{ marginRight: 8 }}>現場/預租過濾：</label>
          <select value={codeFilter} onChange={this.handleCodeFilterChange} style={{ minWidth: 120 }}>
            <option value={''}>不限</option>
            <option value={'S'}>現場</option>
            <option value={'R'}>預租</option>

          </select>

          <label style={{ marginRight: 8 }}>狀態過濾：</label>
          <select value={statusFilter} onChange={this.handleStatusFilterChange} style={{ minWidth: 120 }}>
            <option value={-1}>不限</option>
            <option value={1}>待處理</option>
            <option value={3}>待退款</option>
            <option value={2}>待審查</option>
            <option value={4}>已完成</option>
            <option value={5}>已鎖定</option>
            <option value={99}>已刪除</option>

          </select>
        </div>
          <div className="u-table-responsive">
            <table className="table table-bordered table-striped" style={{color:'black'}}>
              <thead>
                <tr>
                  <th>預款日期</th>
                  <th>預收金額</th>
                  <th>承租人</th>
                  <th>收款後五碼</th>
                  <th>承租空間</th>
                  <th>承租日期</th>
                  <th>場租金額</th>
                  {/* <th>服務費有無</th>
                  <th>服務費</th>
                  <th>服務費%</th>
                  <th>餐費有無</th>
                  <th>餐費</th> */}
                  <th>總收款金額</th>
                  <th>發票號碼</th>
                  {/* <th>品項</th>
                  <th>備註</th> */}
                  <th>編碼</th>
                  <th>帳戶截圖</th>
                  <th>操作</th>
                  <th>請款單</th>
                </tr>
              </thead>
              <tbody>
                {rentalList.length === 0 ? (
                  <tr>
                    <td colSpan="15" style={{ textAlign: 'center' }}>無資料</td>
                  </tr>
                ) : (
                  rentalList.map((item, idx) => {
                    let bgColor = '';
                    switch (item.status) {
                      case 1: bgColor = '#ffe4ea'; break;      // 粉紅
                      case 2: bgColor = '#fff7e0'; break;      // 米黃
                      case 3: bgColor = '#e0f3ff'; break;      // 粉藍
                      case 4: bgColor = '#e0ffe4'; break;      // 粉綠
                      case 5: bgColor = '#999'; break;      // 粉綠
                      default: bgColor = '';
                    }
                    return (
                      <tr key={idx} style={{ background: bgColor }}>
                        <td>{item.prepaymentDate ? moment(item.prepaymentDate).format('YYYY-MM-DD') : ''}</td>
                        <td>{item.prepaymentAmount || ''}</td>
                        <td>{item.tenantName || ''}</td>
                        <td>{item.paymentCode || ''}</td>
                        <td>{item.rentalSpace || ''}</td>
                        <td>{item.rentalDate ? moment(item.rentalDate).format('YYYY-MM-DD') : ''}</td>
                        <td>{item.rentalAmount || ''}</td>
                        <td>{item.totalAmount || ''}</td>
                        <td>
                          {item.invoiceNumber ? 
                            (() => {
                              const regex = /([A-Z]+-\d+)/g;
                              const parts = item.invoiceNumber.split(regex).filter(Boolean);
                              return parts.map((part, i) => {
                                if (regex.test(part)) {
                                  regex.lastIndex = 0; // 重置正则
                                  return <React.Fragment key={i}>{part}<br /></React.Fragment>;
                                }
                                return <React.Fragment key={i}>{part}</React.Fragment>;
                              });
                            })()
                            : ''}
                        </td>
                        <td>{item.code || ''}</td>
                        <td>{item.accountDocumentPath ? (<>
    <button  className="btn btn-md success" onClick={() => window.open(item.accountDocumentPath, '_blank')}>
      查看
    </button>
    <br />
        <button  className="btn btn-md delete" onClick={() => { // 直接在 onClick 中寫入所有邏輯
          swal.fire({
            title: '您確定嗎？',
            text: "您將無法還原此操作！",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: '是',
            cancelButtonText: '取消'
          }).then((result) => {
            if (result.value) {
              API.delete(`Income/Rentall/Account/${item.id}`)
                .then(response => {
                  swal.fire('已刪除!', '您的資料已被成功刪除。', 'success');
                  this.loadRentalList(); // 重新載入租借列表
                })
                .catch(error => {
                  swal.fire('錯誤', '刪除失敗，請稍後再試。', 'error');
                });
            }
          });
        }}>
      刪除
    </button></>
  ) : ''}</td>
                        <td>
                          {
                            item.status !==5 ? (
                              <button className="btn btn-md edit" onClick={() => this.handleEdit(item)}>編輯</button>
                            ) : ''
                          }
                          <br />
                          <button className="btn btn-md save " style={{width:'100px'}} onClick={() => this.showUploadModal(item.id)}>上傳圖片</button>
                          <br />
                          <button className="btn btn-md success" onClick={() => this.handlePrint(item)}>列印</button>
                          <br />
                          {
                            item.status !==5 ? (
                          <button className="btn btn-md delete" onClick={() => this.handleDelete(item)}>刪除</button>
                            ) : ''
                          }
                          <br />
                          {
                            detailRoleId === '40' && item.status !==5 ? (
                                <button className="btn btn-md lock" onClick={() => this.lockFunc(item)}>鎖定</button>
                            ) : ''
                          }
                        </td>
                        <td>
                          <button className="btn btn-md info" style={{width:'110px'}} onClick={() => this.handleApplyPayment(item)}>申請請款單</button>
                          <br />
                          <button className="btn btn-md success" style={{width:'110px'}} onClick={() => this.handlePrintApplyPayment(item)}>列印請款單</button>

                        </td>
                      </tr>
                    );
                  })
                )}
              </tbody>
            </table>
          </div>
          <div className="pagination-box">
            <Pagination
              currPage={currPage}
              totalPage={totalPage}
              onChangPage={this.handleChangePage}
            />
          </div>
        </div>
          <EditRentall
            editType={editType}
            isShow={showEdit}
            editData={editData}
            onChangeFunc={this.onChangeFunc}
            saveFunc={this.saveFunc}
            toggleFunc={this.toggleFunc}
            rentType={rentType}
            tenantList={this.state.tenantList} // 新增這行
          />
{showPrint && (
  <PrintPortal onClose={this.togglePringFunc}>
    {/* PrintRentall 現在是一個純內容元件 */}
    <PrintRentall
      editType={editType}
      editData={editData}
      // 在新視窗中，這些函式通常不會被用到，但您可以傳入
      onChangeFunc={this.onChangeFunc}
      // saveFunc={this.saveFunc}
      toggleFunc={this.togglePringFunc} // 傳入給 PrintRentall 內部可能使用的關閉邏輯
      rentType={rentType}
      tenantList={this.state.tenantList}
    />
  </PrintPortal>
)}
          {/* <PrintRentall
            editType={editType}
            isShow={showPrint}
            editData={editData}
            onChangeFunc={this.onChangeFunc}
            saveFunc={this.saveFunc}
            toggleFunc={this.togglePringFunc}
            rentType={rentType}
            tenantList={this.state.tenantList} // 新增這行
          /> */}
          <ApplyPaymentModal
            isShow={showApplyPayment}
            rentalData={applyPaymentData}
            onChangeFunc={this.onChangeFunc}
            saveFunc={this.saveApplyPaymentFunc}
            toggleFunc={this.toggleApplyPaymentFunc}
          />
{showPrintApplyPayment && printApplyPaymentData && (
  <PrintPortal onClose={this.togglePrintApplyPaymentFunc}>
    <PrintApplyPayment
      isShow={showPrintApplyPayment}
      rentalData={printApplyPaymentData.rentalData}
      paymentData={printApplyPaymentData.paymentData}
    />
  </PrintPortal>
)}
      </div>
    );
  }
}

export default RentalList;